export const befUploadStatus = [
  {name: '의령', office: '5400', whether: true},
  {name: '칠곡', office: 'B700', whether: true},
  {name: '음성', office: '1701', whether: true},
  {name: '순천', office: 'Z101', whether: true},
  {name: '순천', office: 'Z102', whether: true},
  {name: '화순', office: 'Z700', whether: true},
  {name: '양산', office: '0801', whether: true},
  {name: '청도', office: 'C900', whether: true},
  {name: '경주', office: '7900', whether: true},
  {name: '영월', office: 'D101', whether: true},
  {name: '괴산', office: 'Z200', whether: true},
  {name: '보성', office: 'A800', whether: false},
  {name: '김천', office: '4700', whether: false},
  {name: '김포', office: '5701', whether: false},
  {name: '완주', office: 'H101', whether: false},
  {name: '임실', office: 'A600', whether: false},
  {name: '함양', office: '1900', whether: false},
  {name: '증평', office: '7601', whether: false},
  {name: '증평', office: '7602', whether: false},
  {name: '천안', office: '3801', whether: false},
  {name: '시흥', office: '5800', whether: false},
  {name: '세종', office: '8601', whether: false},
  {name: '홍성', office: '7001', whether: false},
  {name: '영천', office: 'C100', whether: false},
]

export const dataUploadStatus = [
  {name: '천안', office: '3801', whether: true},
  {name: '의령', office: '5400', whether: true},
  {name: '양산', office: '0801', whether: false},
  {name: '음성', office: '1701', whether: false},
  {name: '순천', office: 'Z101', whether: false},
  {name: '순천', office: 'Z102', whether: false},
  {name: '칠곡', office: 'B700', whether: false},
  {name: '보성', office: 'A800', whether: false},
  {name: '김천', office: '4700', whether: false},
  {name: '김포', office: '5701', whether: false},
  {name: '완주', office: 'H101', whether: false},
  {name: '임실', office: 'A600', whether: false},
  {name: '함양', office: '1900', whether: false},
  {name: '증평', office: '7601', whether: false},
  {name: '증평', office: '7602', whether: false},
  {name: '세종', office: '8601', whether: false},
  {name: '화순', office: 'Z700', whether: false},
  {name: '홍성', office: '7001', whether: false},
  {name: '영천', office: 'C100', whether: false},
  {name: '시흥', office: '5800', whether: false},
]

export const fileMimeMap: Record<'xlsx' | 'dat', string> = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  dat: 'application/octet-stream',
}

export const officeDownloadFormatMap: Record<string, 'xlsx' | 'dat'> = {
  '5400': 'dat',
  B700: 'dat',
  A800: 'dat',
  '1701': 'dat',
  Z101: 'dat',
  Z102: 'dat',
  '4700': 'xlsx',
  '5701': 'xlsx',
  H101: 'xlsx',
  A600: 'xlsx',
  '1900': 'dat',
  '7601': 'dat',
  '7602': 'dat',
  '3801': 'xlsx',
  '8601': 'dat',
  Z700: 'dat',
  C100: 'dat',
  '7001': 'xlsx',
  '0801': 'dat',
  C900: 'dat',
  7900: 'dat',
  5800: 'xlsx',
  D101: 'xlsx',
  Z200: 'dat',
}

export interface OptionItem {
  value: string
  label: string
}

interface OptionStatusItem {
  name: string
  office: string
  whether: boolean
  options: OptionItem[]
}

export const optionStatus: OptionStatusItem[] = [
  {
    name: '천안',
    office: '3801',
    whether: true,
    options: [
      {value: 'all', label: '전체'},
      {value: '021075', label: '서동춘'},
      {value: '021101', label: '유재영'},
      {value: '021115', label: '이인서'},
      {value: 'no', label: '미할당'},
    ],
  },
  {
    name: '의령',
    office: '5400',
    whether: true,
    options: [
      {value: 'all', label: '전체'},
      {value: '012', label: '서희승'},
      {value: '013', label: '임채현'},
      {value: '014', label: '주일연'},
      {value: '015', label: '이홍연'},
      {value: '016', label: '권삼연'},
      {value: '017', label: '최미란'},
      {value: '018', label: '박정림'},
      {value: '019', label: '이현윤'},
      {value: '020', label: '박신자'},
      {value: '021', label: '천희숙'},
      {value: 'no', label: '미할당'},
    ],
  },
  {
    name: '화순',
    office: 'Z700',
    whether: true,
    options: [
      {value: 'all', label: '전체'},
      {value: '057', label: '양준원'},
      {value: '060', label: '나병욱'},
      {value: 'no', label: '미할당'},
    ],
  },
]
export interface CooperItem {
  value: string
  label: string
}

interface CooperStatusItem {
  name: string
  office: string
  whether: boolean
  options: CooperItem[]
}

export const cooperStatus: CooperStatusItem[] = [
  {
    name: '보성',
    office: 'A800',
    whether: true,
    options: [
      {value: 'all', label: '전체'},
      {value: '1', label: '영아이티(주)'},
      {value: '4', label: '케이스마트피아'},
      {value: '5', label: '청호정밀'},
      {value: '9', label: '삼원미터텍'},
    ],
  },
  {
    name: '의령',
    office: '5400',
    whether: true,
    options: [
      {value: 'all', label: '전체'},
      {value: '1', label: '영아이티(주)'},
      {value: '8', label: '아이에스테크놀러지'},
    ],
  },
  {
    name: '순천',
    office: 'Z101',
    whether: true,
    options: [
      {value: 'all', label: '전체'},
      {value: '1', label: '영아이티(주)'},
      {value: '4', label: '케이스마트피아'},
      {value: '6', label: '하이텍앤솔'},
    ],
  },
]

export const checkDayStatus: Record<string, boolean> = {
  3801: true,
  Z700: true,
  5800: true,
  7900: true,
  B700: true,
}
